module.exports = __webpack_public_path__ + "media/images/front/common/slideArwL-c07b37604a58e967d014e414f65eef89.png";